import type { NodePropertyValue } from '../../../types/properties';

const defaults: Record<string, NodePropertyValue> = {
  method: 'GET',
  url: '',
  headers: '{}',
  body: '{}',
  timeout: 30000,
};

export default defaults;
